import { PageTitle } from "shared/components/molecules/PageTitle";
import { Coupon } from "features/coupon-histories/components/Coupon";
import { css } from "styled-components";
import { CampaignCoupon } from "features/shared/utils/coupon";

interface Props {
  coupon: CampaignCoupon;
}

export const ReceiveTelFortuneCoupon = ({ coupon }: Props) => {
  const couponCatchCopy =
    coupon?.catchCopy ||
    "はじめての電話占いで利用できる3000円分無料クーポンがプレゼントされました！";
  const couponName = "電話占いが初回無料！？電話占い3000円分無料クーポン";
  const couponDescription =
    coupon?.description ||
    "電話鑑定をご利用された事がないお客様限定で、0円~電話鑑定をお楽しみいただけるクーポンを配布させていただきました。";
  const couponExpiry =
    coupon?.expiredAt?.format("YYYY/MM/DD HH:mm") ||
    "ログイン後にご確認ください";
  const couponPrice = coupon?.discountAmount || 3000;

  return (
    <>
      <PageTitle
        title="クーポンが付与されました🎉"
        description={couponCatchCopy}
      />
      <div tw="relative">
        <Coupon
          name={couponName}
          description={couponDescription}
          expiry={couponExpiry}
          price={couponPrice}
          css={css({
            transform: "rotate(3deg)",
            "> div": {
              backgroundImage: "linear-gradient(45deg, #CC67BA, #F41BBB)",
            },
          })}
          tw="text-left"
        />
        <Coupon
          name={couponName}
          description={couponDescription}
          expiry={couponExpiry}
          price={couponPrice}
          css={css({
            transform: "rotate(-2deg)",
            "> div": {
              backgroundImage: "linear-gradient(45deg, #E68AB4, #FE4FD0)",
            },
          })}
          tw="absolute top-0 w-full text-left"
        />
      </div>
      <p tw="text-secondary text-[9px] leading-3 mt-8 text-left">
        ※MIRORの電話鑑定で特に満足度の高い、運営が厳選した人気占い師限定でご利用いただけるクーポンになります。
        <br />
        ※クーポンをご利用いただくことで電話鑑定が0円〜ご利用いただけますので、この機会にぜひお試しください。
      </p>
    </>
  );
};
